import MasonryGrid from '../components/MasonryGrid';

export default class StaticBlogMasonry {
  constructor({ el }) {
    const masonry = el.querySelector('[data-masonry-grid]');

    this.masonryGrid = new MasonryGrid({ el: masonry });
  }

  onSectionUnload() {
    return this.masonryGrid.unload();
  }
}
